type EnvConfig = {
  SERVICE_API: string;
  APP_API: string;
  WX_API: string;
  HELLOBIKE_API: string;
  ADMIN_API: string;
};

const config: Record<string, EnvConfig> = {
  dev: {
    SERVICE_API: 'https://dev-admin-server.hellobike.cn',
    APP_API: 'https://fat-miaowa.hellobike.com',
    WX_API: 'https://fat-api.hellobike.com',
    HELLOBIKE_API: 'https://fat-api.hellobike.com/api',
    ADMIN_API: 'https://fat-bff-admin.hellobike.cn/general/bffGeneralReq',
  },
  pt: {
    SERVICE_API: 'https://pt-admin-server.hellobike.cn',
    APP_API: 'https://fat-miaowa.hellobike.com',
    WX_API: 'https://fat-api.hellobike.com',
    HELLOBIKE_API: 'https://fat-api.hellobike.com/api',
    ADMIN_API: 'https://fat-bff-admin.hellobike.cn/general/bffGeneralReq',
  },
  fat: {
    SERVICE_API: 'https://fat-admin-server.hellobike.cn',
    APP_API: 'https://fat-miaowa.hellobike.com',
    WX_API: 'https://fat-api.hellobike.com',
    HELLOBIKE_API: 'https://fat-api.hellobike.com/api',
    ADMIN_API: 'https://fat-bff-admin.hellobike.cn/general/bffGeneralReq',
  },
  uat: {
    SERVICE_API: 'https://uat-admin-server.hellobike.cn',
    APP_API: 'https://uat-miaowa.hellobike.com',
    WX_API: 'https://uat-api.hellobike.com',
    HELLOBIKE_API: 'https://uat-api.hellobike.com/api',
    ADMIN_API: 'https://uat-bff-admin.hellobike.cn/general/bffGeneralReq',
  },
  pre: {
    SERVICE_API: 'https://pre-admin-server.hellobike.cn',
    APP_API: 'https://pre-miaowa.hellobike.com',
    WX_API: 'https://pre-api.hellobike.com',
    HELLOBIKE_API: 'https://pre-api.hellobike.com/api',
    ADMIN_API: 'https://pre-bff-admin.hellobike.cn/general/bffGeneralReq',
  },
  pro: {
    SERVICE_API: 'https://pro-admin-server.hellobike.cn',
    APP_API: 'https://miaowa.hellobike.com',
    WX_API: 'https://api.hellobike.com',
    HELLOBIKE_API: 'https://api.hellobike.com/api',
    ADMIN_API: 'https://bff-admin.hellobike.cn/general/bffGeneralReq',
  },
} as const;

export default config[process.env.REACT_APP_ENV || 'dev'];
